import React from "react";
import { useParams } from "react-router-dom";
import { Typography } from "@mui/material";
import { ViewContainer } from "../ViewContainer/ViewContainer";

import { useGA } from "../common/hooks";
import { Mode } from "../interfaces/mode";
import { getBlogBySlug } from "./blog-items";

import { BlogCaption, BlogNextMobile } from "./BlogCaption/BlogCaption";
import { BlogContent } from "./BlogContent/BlogContent";
import { BlogAuthor } from "./BlogAuthor/BlogAuthor";
import { BlogFooter } from "./BlogFooter/BlogFooter";

export const BlogSingle = () => {
  const { blogSlug } = useParams();
  useGA(`BlogSingle - ${blogSlug}`);
  const blog = blogSlug ? getBlogBySlug(blogSlug) : undefined;

  return (
    <ViewContainer mode={Mode.Dark}>
      {blog ? (
        <>
          <BlogCaption blog={blog} />

          <BlogContent blog={blog} />

          {(blog.authors || blog.author) && (
            <BlogAuthor author={blog.author} authors={blog.authors} />
          )}

          <BlogNextMobile blog={blog} />

          <BlogFooter blog={blog} />
        </>
      ) : (
        <Typography variant="h1">Blog not found</Typography>
      )}
    </ViewContainer>  
  );
};

